<template>
  <div class="animated fadeIn">
    <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
      <div>
        <b-row>
          <b-col sm='6'>
            <button @click="handleSavingContent">게시물 저장</button>
            <vue-editor
                :editorOptions="editorSettings"
                v-model="content">
            </vue-editor>
          </b-col>
          <b-col sm='6'>
            <div v-html="content"></div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor'
import { ImageDrop } from 'quill-image-drop-module'
// import ImageResize from 'quill-image-resize-module'

Quill.register('modules/imageDrop', ImageDrop)
// Quill.register('modules/imageResize', ImageResize)

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      content: '<h1>Initial Content</h1>',
      editorSettings: {
        modules: {
          imageDrop: true,
          // imageResize: {}
        }
      },
      boardContentData:{
        type:'notice',
        title:'게시물테스트',
        content:'',
        top_yn:'N',
        notice_yn:'Y',
        attached_file_id:null,
        user_id:null
      }
    }
  },
  watch: {
    'content': function() {
      console.log(this.content);
    }
  },
  methods: {
    handleSavingContent: function() {
      // You have the content to save
      // this.boardContentData.content = window.btoa(this.content);
      this.boardContentData.content = this.content;
      this.boardContentData.user_id = this.$session.get('email');
      // console.log(this.boardContentData.content)
      // console.log(window.atob(this.boardContentData.content));

      var token = sessionStorage.getItem("myToken");
      // var param = encodeURI(JSON.stringify(this.boardContentData));
      var param = JSON.stringify(this.boardContentData);

      var data = new FormData();
      data.append('objs', param);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      this.$http.post('/api/insert/managementContent?access_token='+token, data,config)
        .then((result) => {

      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/management/board/BoardEditor.vue